import React from "react";

const baseClasses =
  "inline-flex items-center justify-center gap-2 font-sans font-semibold rounded-lg transition-colors duration-150 ease-out disabled:opacity-50 disabled:pointer-events-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40";

const variants = {
  primary: "bg-primary text-on-primary hover:bg-primary-fixed",
  secondary: "border border-outline bg-transparent text-on-surface hover:bg-on-surface/[.06]",
  ghost: "bg-transparent text-on-surface-variant hover:text-on-surface hover:bg-on-surface/[.06]",
  danger: "border border-error/50 bg-transparent text-error hover:bg-error/10",
  "danger-solid": "bg-error text-on-error hover:opacity-90",
  tertiary: "bg-transparent text-primary hover:text-primary-fixed",
};

const sizes = {
  xs: "px-3 py-1.5 text-xs",
  sm: "px-3.5 py-2 text-[13px]",
  md: "px-4 py-2.5 text-[13px]",
  lg: "px-5 py-3 text-sm",
};

export default function Button({
  type = "button",
  variant = "primary",
  size = "md",
  icon,
  iconRight,
  fullWidth,
  loading = false,
  className = "",
  children,
  ...props
}) {
  return (
    <button
      type={type}
      className={`${baseClasses} ${variants[variant] || variants.primary} ${sizes[size]} ${fullWidth ? "w-full" : ""} ${className}`}
      {...props}
      disabled={props.disabled || loading}
      aria-busy={loading || props["aria-busy"]}
    >
      {icon && (
        <span
          className={`material-symbols-outlined shrink-0 text-lg leading-none ${loading ? "animate-spin motion-reduce:animate-none" : ""}`}
          aria-hidden="true"
        >
          {loading ? "progress_activity" : icon}
        </span>
      )}
      {children}
      {iconRight && (
        <span
          className="material-symbols-outlined shrink-0 text-lg leading-none"
          aria-hidden="true"
        >
          {iconRight}
        </span>
      )}
    </button>
  );
}
